import { sliceQawaemStats } from '../../products/saudi/components/QawaemErpListPageShell';

/** Map legacy stat card defs to QawaemErpListPageShell stats (max 4). */
export function mapStatsForListShell(stats = [], max = 4) {
  return sliceQawaemStats(
    stats.map((stat, i) => ({
      key: stat.key || stat.labelKey || stat.titleKey || stat.label || stat.title || i,
      label: stat.label || stat.title || stat.labelKey || stat.titleKey,
      value: stat.value,
      icon: stat.icon,
      variant: stat.variant || (i % 2 === 0 ? 'copper' : 'forest'),
      className: stat.className,
    })),
    max,
  );
}

/** Standard import/export toolbar props for list pages. */
export function buildListImportExportProps({
  showImportDropdown,
  setShowImportDropdown,
  showExportDropdown,
  setShowExportDropdown,
  importDropdownRef,
  exportDropdownRef,
  importLabel,
  exportLabel,
  generatingLabel,
  isGeneratingPDF = false,
  handlers = {},
}) {
  return {
    importOpen: showImportDropdown,
    exportOpen: showExportDropdown,
    onToggleImport: () => {
      setShowImportDropdown(!showImportDropdown);
      setShowExportDropdown(false);
    },
    onToggleExport: () => {
      setShowExportDropdown(!showExportDropdown);
      setShowImportDropdown(false);
    },
    importRef: importDropdownRef,
    exportRef: exportDropdownRef,
    importLabel,
    exportLabel,
    generatingLabel,
    isGeneratingPDF,
    onImportCSV: handlers.onImportCSV || (() => {}),
    onImportExcel: handlers.onImportExcel || (() => {}),
    onImportJSON: handlers.onImportJSON || (() => {}),
    onExportPDF: handlers.onExportPDF || (() => {}),
    onExportExcel: handlers.onExportExcel || (() => {}),
    onExportCSV: handlers.onExportCSV || (() => {}),
    onExportJSON: handlers.onExportJSON || (() => {}),
    showJsonImportExport: handlers.showJsonImportExport ?? false,
  };
}

/** Build secondary filter props from a status/all filter pattern. */
export function buildStatusSecondaryFilter({
  statusFilter,
  setStatusFilter,
  allLabel,
  options = [],
  allValue = 'all',
  icon,
}) {
  const value = !statusFilter || statusFilter === allValue ? allValue : statusFilter;
  const selected = options.find((o) => o.value === value);
  return {
    label: value === allValue ? allLabel : (selected?.label || value),
    value,
    options: [{ value: allValue, label: allLabel }, ...options],
    onChange: (val) => setStatusFilter(val === allValue ? allValue : val),
    icon,
  };
}
